export const BBPayAmountCount = (amount, disc) => {
    let multipleAmt = amount - (amount * disc) / 100
    return multipleAmt
}